import { PropsWithChildren } from 'react';
import { useAppAuth } from '@/hooks/useAppAuth';

interface RequireRoleProps {
  role: string;
}

/**
 * RequireRole component wraps elements that require a specific role.
 * If the user doesn't have the required role, the children are not rendered.
 */
export function RequireRole({ role, children }: PropsWithChildren<RequireRoleProps>) {
  const { user } = useAppAuth();
  
  if (!user) {
    return null;
  }

  const userRoles = user.roles || [];
  
  // Normalize role names for comparison
  const normalizedRequiredRole = role.toLowerCase();
  
  const normalizedUserRoles = userRoles.map((userRole: any) => {
    const roleString = typeof userRole === 'string'
      ? userRole
      : userRole?.name || userRole?.key || '';
    return roleString.toLowerCase();
  });

  // Admin role implicitly includes Builder permissions
  const hasRole = normalizedUserRoles.includes(normalizedRequiredRole)
    || (normalizedRequiredRole === 'builder' && normalizedUserRoles.includes('admin'));

  if (!hasRole) {
    return null;
  }

  return <>{children}</>;
}

